import React from "react";
import { useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const deleteEmployee = async ({ companyCode, Code }) => {
  if (!companyCode || !Code) {
    throw new Error("Company ID and Employee ID are required");
  }

  const data = await http_payroll.delete(
    `${Api_EndPoints.DeleteEmployee}?CompanyCode=${companyCode}&Code=${Code}`
  );
  return data;
};

export const useDeleteEmployeeMutation = () => {
  return useMutation({
    mutationFn: deleteEmployee,
  });
};
